import { gsap } from '../vendor/gsap';
import animateOnScroll from '../lib/animateOnScroll';
import windowSize from '../lib/windowSize';

const sectionSelector = '.internal-page-banner-section';
const sectionCallBack = (sectionElement, query, queryAll) => {
    const loadImage = queryAll('.image');
    const timeline = gsap.timeline({
        paused: true,
    });
    timeline.addLabel('start');
    timeline.fromTo(loadImage, { opacity: '0' }, {
        opacity: '1', duration: 0.25, ease: 'easeOut',
    }, 'start+=0');
    animateOnScroll(sectionElement, () => timeline.play(), () => windowSize.height * 0.1);
};

export { sectionSelector, sectionCallBack };
